(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-pepp-text.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-pepp-text.js');

'use strict';

var _svs$lyckoplatsen$dat;
const charityPayoutPageInfo = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.charityPayoutPageInfo;
const CmsTextFormatter = svs.lyckoplatsen.shared_utils.react.components.CmsTextFormatter;
const CharityPeppText = () => React.createElement("div", {
  className: "charity-pepp-text charity-grid"
}, React.createElement("div", {
  className: "charity-grid-body ".concat(charityPayoutPageInfo === null || charityPayoutPageInfo === void 0 ? void 0 : charityPayoutPageInfo.color)
}, React.createElement("p", {
  className: "f-500 padding-top-1 padding-bottom-1"
}, React.createElement(CmsTextFormatter, {
  text: charityPayoutPageInfo === null || charityPayoutPageInfo === void 0 ? void 0 : charityPayoutPageInfo.textDescription2
})), React.createElement("p", {
  className: "f-500 padding-bottom-1"
}, React.createElement(CmsTextFormatter, {
  text: charityPayoutPageInfo === null || charityPayoutPageInfo === void 0 ? void 0 : charityPayoutPageInfo.textDescription3
}))));
Object.assign(svs.lyckoplatsen.components.page_charity_payout.react.components, {
  CharityPeppText
});

 })(window);